var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 118.59 81.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:#009408;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#radial-gradient-2);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#radial-gradient-3);}.cls-7{fill:#1f5ba2;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#radial-gradient-4);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#radial-gradient-5);}.cls-12{fill:#93278f;}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#radial-gradient-6);}.cls-15{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 113.65,
    cy: 43.75,
    r: 12.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "lime"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00df14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00b52f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#009c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.46,
    y1: 190.7,
    x2: 21.46,
    y2: 195.24,
    gradientTransform: "translate(-37.85 -103.36) rotate(-34.24)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 101.89,
    cy: 43.93,
    r: 19.77,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 102,
    y1: 15.2,
    x2: 102,
    y2: 20.73,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 34.52,
    cy: 44.03,
    r: 15.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00b5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#008edd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0073cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0062c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005cbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -45.07,
    y1: 143.01,
    x2: -45.3,
    y2: 146.49,
    gradientTransform: "matrix(0.91, -0.43, 0.43, 0.91, -16.54, -105.97)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 20.93,
    cy: 39.17,
    r: 12.59,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20.85,
    y1: 8.51,
    x2: 20.23,
    y2: 17.88,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 82.67,
    cy: 48.19,
    r: 21.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff87f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f173ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#d44ad0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#be2abc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ae13ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a405a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a100a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -22.33,
    y1: 166.19,
    x2: -22.33,
    y2: 174.12,
    gradientTransform: "translate(-37.85 -103.36) rotate(-34.24)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 64.01,
    cy: 39.38,
    r: 14.77,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 63.02,
    y1: 1.51,
    x2: 63.02,
    y2: 9.76,
    xlinkHref: "#radial-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.4,42.76h-4.3a4,4,0,0,1-4-4v-.16a4,4,0,0,0-4-4h-.26a4,4,0,0,0-4,4v.16a4,4,0,0,1-4,4h-4.3a4,4,0,0,0-4,4V61.65C93.49,63,95.92,62.8,102.4,62.8s8.18-.21,16-1.55V46.74A4,4,0,0,0,114.4,42.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.7,63a66.64,66.64,0,0,1-13.14-1.16l-.17,0V46.74a4.2,4.2,0,0,1,4.19-4.19h4.3a3.78,3.78,0,0,0,3.78-3.78v-.16a4.2,4.2,0,0,1,4.2-4.2h.26a4.2,4.2,0,0,1,4.2,4.2v.16a3.78,3.78,0,0,0,3.78,3.78h4.3a4.2,4.2,0,0,1,4.19,4.19V61.42l-.17,0c-7.77,1.34-9.5,1.56-16,1.56ZM85.81,61.48A66.31,66.31,0,0,0,98.7,62.6h3.7c6.44,0,8.18-.21,15.77-1.52V46.74A3.78,3.78,0,0,0,114.4,43h-4.3a4.22,4.22,0,0,1-3.62-2.07,4.15,4.15,0,0,1-.58-2.12v-.16a3.78,3.78,0,0,0-3.78-3.78h-.26a3.78,3.78,0,0,0-3.78,3.78v.16A4.2,4.2,0,0,1,93.88,43h-4.3a3.78,3.78,0,0,0-3.77,3.78V61.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.13,43.57c.45.66-4.47,3.67-5.62,4.45S85.7,48,86,46.86a4.81,4.81,0,0,1,1.68-3C88.79,43.07,92.69,42.92,93.13,43.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.4,21.09c-.52-4.13-5.19-4.72-7.38-4.72h-2.33c-2.19,0-7,.86-7,4.72v4.85a8.27,8.27,0,0,0,.45,2.4l.06,0,.13,0c.16.09.29-.67.29-1.7v2a.55.55,0,0,0-.42-.12h0a.5.5,0,0,0,0-.13l-.31.07c0,.22,0,.43,0,.61a4.49,4.49,0,0,0,.07,2c.3,1.33,1,2.3,1.46,2.19a.44.44,0,0,0,.23-.16c1.19,3.26,3.4,6.53,5.86,6.53h1.46c2.46,0,4.55-3.27,5.66-6.52a.54.54,0,0,0,.23.15c.5.11,1.16-.86,1.47-2.19a4.06,4.06,0,0,0,0-2.28,1.09,1.09,0,0,0,0-.37l-.22-.05-.05.14-.1,0a.56.56,0,0,0-.49.18v-2c0,1,.15,1.79.34,1.67l.15,0,.15,0a8.47,8.47,0,0,0,.36-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.89,39.83h-1.46c-2.6,0-4.81-3.39-6-6.41l-.08,0h-.13c-.72,0-1.32-1.21-1.58-2.35A4.63,4.63,0,0,1,93.61,29l.06-.77h.24a7.88,7.88,0,0,1-.4-2.25V21.09c0-3.9,4.7-4.93,7.18-4.93H103c1.63,0,7,.35,7.59,4.9v4.88a8.27,8.27,0,0,1-.31,2.26l.15,0,0,.15a1.53,1.53,0,0,1,0,.37,4.39,4.39,0,0,1,0,2.35c-.27,1.14-.88,2.35-1.58,2.35h-.13l-.08,0c-1.12,3.14-3.2,6.4-5.77,6.4Zm-7.25-7.15.12.34c1.08,2.95,3.21,6.4,5.67,6.4h1.46c2.43,0,4.46-3.44,5.47-6.39l.12-.35.23.28a.21.21,0,0,0,.12.08h0c.33,0,.91-.72,1.21-2a3.84,3.84,0,0,0,0-2.15l0-.06v-.06l-.13-.07,0-.15,0,.13a.44.44,0,0,0-.27.13l-.34.31V26.62h.41a5,5,0,0,0,.15,1.43h0l0,0,.1,0a8,8,0,0,0,.3-2.17V21.09c-.53-4.19-5.62-4.52-7.17-4.52h-2.33c-2.34,0-6.76.95-6.76,4.52v4.85a7.58,7.58,0,0,0,.38,2.12,5.69,5.69,0,0,0,.13-1.47h.42V29l-.33-.25a.4.4,0,0,0-.22-.09l-.2,0-.06-.1L94,29a4.34,4.34,0,0,0,.06,2c.3,1.3.89,2,1.18,2a.26.26,0,0,0,.15-.09l.23-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.2,20c0,2-2.77,3.54-6.2,3.54S95.81,22,95.81,20s2.77-3.54,6.19-3.54S108.2,18,108.2,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.43,42.81H30.18a4.88,4.88,0,0,1-4.87-4.87v-.19a4.88,4.88,0,0,0-4.87-4.87h-.33a4.88,4.88,0,0,0-4.86,4.87v.19a4.89,4.89,0,0,1-4.87,4.87H5.12A4.9,4.9,0,0,0,.25,47.69V65.9c9.64,1.62,12.61,1.4,20.53,1.4s10-.25,19.52-1.9V47.69A4.89,4.89,0,0,0,35.43,42.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16.26,67.56a81.22,81.22,0,0,1-16-1.41l-.21,0V47.69a5.13,5.13,0,0,1,5.12-5.13h5.26A4.62,4.62,0,0,0,15,37.94v-.19a5.13,5.13,0,0,1,5.12-5.13h.33a5.13,5.13,0,0,1,5.12,5.13v.19a4.62,4.62,0,0,0,4.62,4.62h5.25a5.13,5.13,0,0,1,5.12,5.13V65.62l-.21,0c-9.47,1.64-11.58,1.9-19.56,1.9ZM.51,65.68a80.48,80.48,0,0,0,15.75,1.38l4.52,0c7.88,0,10-.25,19.27-1.85V47.69a4.62,4.62,0,0,0-4.62-4.62H30.18a5.13,5.13,0,0,1-5.12-5.13v-.19a4.62,4.62,0,0,0-4.62-4.62h-.33a4.62,4.62,0,0,0-4.61,4.62v.19a5.13,5.13,0,0,1-5.12,5.13H5.12A4.62,4.62,0,0,0,.51,47.69v18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8.24,43.6c1.61-.17-1.77,1.74-3.48,2.54s-3.61,2.42-4,1.54.62-3,2.33-3.83S7.27,43.7,8.24,43.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M30.55,16.34c-.64-5-6.34-5.76-9-5.76H18.69c-2.68,0-8.51,1.05-8.51,5.76v5.93a10.19,10.19,0,0,0,.55,2.93h.07l.16,0c.2.11.35-.83.35-2.08V25.5a.61.61,0,0,0-.51-.15h0c0-.05,0-.1,0-.16l-.38.09c0,.27,0,.52-.07.75a5.5,5.5,0,0,0,.09,2.49c.37,1.62,1.17,2.81,1.79,2.67a.48.48,0,0,0,.27-.19c1.46,4,4.16,8,7.16,8h1.79c3,0,5.56-4,6.92-8a.47.47,0,0,0,.28.19c.61.14,1.41-1.05,1.78-2.67a4.8,4.8,0,0,0,0-2.78,1.36,1.36,0,0,0,0-.46l-.27-.06-.06.17-.12,0a.71.71,0,0,0-.6.22V23.11c0,1.26.19,2.18.41,2l.19.05.18,0a10.45,10.45,0,0,0,.44-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.38,39.25H19.59c-3.17,0-5.87-4.15-7.28-7.83l-.1,0h-.16c-.87,0-1.61-1.49-1.93-2.87A5.71,5.71,0,0,1,10,26l.07-.85.16-.08.14,0a9.67,9.67,0,0,1-.49-2.75V16.34c0-4.76,5.74-6,8.77-6h2.84c2,0,8.57.44,9.27,6v6A10.44,10.44,0,0,1,30.43,25h.24l0,.23a1.34,1.34,0,0,1,0,.45,5.29,5.29,0,0,1,0,2.87c-.34,1.47-1.21,3.06-2.09,2.86l-.1,0c-1.37,3.84-3.9,7.83-7,7.83Zm-8.86-8.74.15.42c1.32,3.6,3.92,7.81,6.92,7.81h1.79c3,0,5.45-4.21,6.67-7.81l.15-.43.29.35a.25.25,0,0,0,.14.1h0c.4,0,1.11-.88,1.48-2.48a4.53,4.53,0,0,0,0-2.61l0-.09,0-.09h0l-.17-.05a.47.47,0,0,0-.43.14l-.42.38v-3h.51a6,6,0,0,0,.18,1.75h0v0l.13,0a10.1,10.1,0,0,0,.37-2.66V16.34c-.65-5.11-6.87-5.51-8.77-5.51H18.69c-2.86,0-8.26,1.16-8.26,5.51v5.93a9.3,9.3,0,0,0,.46,2.6,6.94,6.94,0,0,0,.17-1.8h.51V26l-.41-.31a.46.46,0,0,0-.26-.12l-.24.07-.08-.13,0,.53a5.45,5.45,0,0,0,.08,2.42C11,30.07,11.7,31,12.05,31a.24.24,0,0,0,.18-.11l.29-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.58,14.46c0,2-3.19,3.69-7.13,3.69s-7.12-1.65-7.12-3.69,3.19-3.69,7.12-3.69S27.58,12.42,27.58,14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M84,46.44H76.46a7,7,0,0,1-7-7V39.2a7,7,0,0,0-7-7h-.47a7,7,0,0,0-7,7v.28a7,7,0,0,1-7,7h-7.5a7,7,0,0,0-7,7v26c13.77,2.32,18,2,29.34,2s14.27-.37,27.9-2.72V53.4A7,7,0,0,0,84,46.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M56.57,81.82a115.2,115.2,0,0,1-22.94-2l-.31,0V53.4a7.33,7.33,0,0,1,7.33-7.32h7.5a6.61,6.61,0,0,0,6.6-6.6V39.2a7.33,7.33,0,0,1,7.32-7.32h.47a7.33,7.33,0,0,1,7.33,7.32v.28a6.55,6.55,0,0,0,.91,3.34,6.63,6.63,0,0,0,5.68,3.26H84a7.32,7.32,0,0,1,7.32,7.32V79l-.3,0C77.42,81.43,74.41,81.8,63,81.8l-6.46,0ZM34.05,79.13a114.84,114.84,0,0,0,22.52,2H63c11.24,0,14.28-.37,27.53-2.65v-25A6.6,6.6,0,0,0,84,46.8H76.46a7.32,7.32,0,0,1-7.32-7.32V39.2a6.61,6.61,0,0,0-6.6-6.6h-.47a6.6,6.6,0,0,0-6.59,6.6v.28a7.33,7.33,0,0,1-7.33,7.32h-7.5a6.61,6.61,0,0,0-6.6,6.6V79.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M46.84,47.87C47.62,49,39,54.27,37,55.63s-3.15-.06-2.69-2c.32-1.35.93-3.89,2.93-5.26S46.06,46.72,46.84,47.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M77.68,8.6C76.77,1.41,68.62.36,64.79.36H60.73C56.9.36,48.56,1.87,48.56,8.6v8.47a15,15,0,0,0,.78,4.2l.11,0,.23,0c.28.15.5-1.18.5-3V21.7a.88.88,0,0,0-.73-.22H49.4a.9.9,0,0,0-.06-.22l-.54.12c0,.38-.06.74-.09,1.07A7.81,7.81,0,0,0,48.83,26c.54,2.31,1.68,4,2.55,3.82a.72.72,0,0,0,.4-.27C53.86,35.26,57.73,41,62,41h2.55c4.29,0,8-5.71,9.88-11.4a.8.8,0,0,0,.4.27c.88.2,2-1.51,2.56-3.82a6.82,6.82,0,0,0,0-4,2,2,0,0,0,.06-.66L77,21.3c0,.09-.05.17-.07.25a.56.56,0,0,0-.18-.07,1,1,0,0,0-.85.31V18.27c0,1.81.26,3.12.59,2.91l.26.06.25.06a14.38,14.38,0,0,0,.64-4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M64.57,41.34H62c-4.54,0-8.4-5.93-10.41-11.19l-.14,0-.23,0c-1.24,0-2.3-2.13-2.76-4.11a8.15,8.15,0,0,1-.12-3.74L48.47,21h.32l.1,0a13.55,13.55,0,0,1-.7-3.93V8.6c0-6.8,8.2-8.6,12.54-8.6h4.06C67.65,0,77,.62,78,8.56v8.51a14.83,14.83,0,0,1-.54,4l.27.06,0,.27a3.54,3.54,0,0,1,0,.65,7.59,7.59,0,0,1,0,4.1c-.47,2-1.53,4.11-2.77,4.11l-.23,0-.13,0c-2,5.49-5.58,11.19-10.07,11.19ZM51.9,28.85l.22.6C54,34.6,57.73,40.61,62,40.61h2.55c4.23,0,7.79-6,9.54-11.15l.21-.61.42.49a.39.39,0,0,0,.2.15h0c.56,0,1.58-1.27,2.12-3.55a6.53,6.53,0,0,0,0-3.74l0-.11,0-.1-.22-.12-.06-.27-.09.22a.8.8,0,0,0-.47.25l-.6.53V18.27h.72a8.67,8.67,0,0,0,.26,2.5l0,0,0,.08.18,0a14.05,14.05,0,0,0,.53-3.8V8.6C76.39,1.3,67.49.73,64.79.73H60.73C56.65.73,48.92,2.37,48.92,8.6v8.47a13.23,13.23,0,0,0,.66,3.72,10,10,0,0,0,.24-2.57h.73v4.21L50,22a.66.66,0,0,0-.37-.17l-.35.08-.1-.17-.07.77a7.82,7.82,0,0,0,.11,3.44c.54,2.29,1.56,3.55,2.06,3.55a.38.38,0,0,0,.26-.15l.4-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M73.84,6.71c0,3.41-4.85,6.18-10.82,6.18S52.2,10.12,52.2,6.71,57,.53,63,.53,73.84,3.29,73.84,6.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.15aec58d00e1587ee7cdfe34674d113d.svg";
export { ForwardRef as ReactComponent };